// external libs
import { Button, makeStyles } from '@material-ui/core'

// hooks
import useTranslate from '../../../../i18n/useTranslate'

export interface RevertProjectStatusButtonProps {
    onClick?: () => void
}

const RevertProjectStatusButton = (props: RevertProjectStatusButtonProps) => {
    const { onClick } = props
    const translate = useTranslate()
    const classes = useStyles()

    return (
        <Button size={'medium'} variant="contained" className={classes.button} onClick={onClick}>
            {translate.get('BUTTON.REVERT_PROJECT_STATUS')}
        </Button>
    )
}

const useStyles = makeStyles(() => ({
    button: {
        backgroundColor: '#FFAC07',
        color: 'white',
        marginBottom: 16,
        '&:hover': {
            backgroundColor: '#E69906',
        },
    },
}))

export default RevertProjectStatusButton
